import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";

const withServerError = (fn) => async (arg, { rejectWithValue }) => {
  try {
    return await fn(arg);
  } catch (error) {
    return rejectWithValue(
      error.response?.data || { success: false, message: error.message }
    );
  }
};

export const settlementBody = (res) => res?.payload?.data ?? res?.payload ?? null;

export const GetTenantSettlementBills = createAsyncThunk(
  "settlementBill/getForTenant",
  withServerError(({ tenantId }) =>
    axios.get(`${BASE_URL}/settlement-bills/tenant/${tenantId}`)
  )
);

export const GetLandlordSettlementBills = createAsyncThunk(
  "settlementBill/getForLandlord",
  withServerError(({ landlordId }) =>
    axios.get(`${BASE_URL}/settlement-bills/landlord/${landlordId}`)
  )
);

export const SubmitSettlementReceipt = createAsyncThunk(
  "settlementBill/submitReceipt",
  withServerError(({ id, receipt }) => {
    const formData = new FormData();
    formData.append("receipt", receipt);
    return axios.post(`${BASE_URL}/settlement-bills/${id}/receipt`, formData);
  })
);

export const VerifySettlementReceipt = createAsyncThunk(
  "settlementBill/verify",
  withServerError(({ id, decision, reason }) =>
    axios.post(`${BASE_URL}/settlement-bills/${id}/verify`, { decision, reason })
  )
);

const SettlementBillSlice = createSlice({
  name: "settlementBill",
  initialState: {
    loading: false,
    bills: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetTenantSettlementBills.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetTenantSettlementBills.fulfilled, (state, action) => {
        state.loading = false;
        state.bills = action.payload?.data?.data || [];
      })
      .addCase(GetLandlordSettlementBills.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetLandlordSettlementBills.fulfilled, (state, action) => {
        state.loading = false;
        state.bills = action.payload?.data?.data || [];
      })
      .addMatcher(
        (action) =>
          [SubmitSettlementReceipt.fulfilled.type, VerifySettlementReceipt.fulfilled.type].includes(
            action.type
          ),
        (state, action) => {
          const updated = action.payload?.data?.data;
          if (updated) {
            state.bills = state.bills.map((b) => (b._id === updated._id ? updated : b));
          }
        }
      );
  },
});

export default SettlementBillSlice.reducer;
